import { useState, useEffect } from 'react'
import {getFieldNameBuilder, initDatePatternState} from "../../util";
import {DatePattern} from "./DatePattern";
import {Periodicity} from "./PeriodicityPattern";
import {monthsIndexed, frequencyTypes} from "../../util";

export const RecurringIntervalConditions = (props) => {

  const [intervalData, setIntervalData] = useState(props.value || {});
  useEffect(() => props.onChange ? props.onChange(intervalData) : null, [intervalData])

  const fieldPrefix = ``;

  const [periodicity, setPeriodicity] = useState({
    period: intervalData.period ?? Object.keys(frequencyTypes).at(0),
    frequency: intervalData.frequency ?? 1
  })
  const [datePatternFrom, setDatePatternFrom] = initDatePatternState(intervalData.period_from ?? {})
  const [datePatternTo, setDatePatternTo] = initDatePatternState(intervalData.period_to ?? {})

  useEffect(() => {
    setIntervalData((intervalData) => ({
      ...intervalData,
      period: periodicity.period,
      frequency: periodicity.frequency
    }));
  }, [periodicity])

  useEffect(() => {
    setIntervalData((intervalData) => ({
      ...intervalData,
      period_from: datePatternFrom
    }));
  }, [datePatternFrom])

  useEffect(() => {
    setIntervalData((intervalData) => ({
      ...intervalData,
      period_to: datePatternTo
    }));
  }, [datePatternTo])


  let startDateYMD = tangibleFields.render({
    type: 'repeater',
    name: 'start_date',
    sectionTitle: 'Starts On',
    value: [intervalData.start_date || {}],
    label: 'Starts On',
    repeatable: false,
    fields: [
      { type: 'number', name: 'year', label: 'Year', minValue: 2000 },
      { type: 'select', name: 'month', label: 'Month', choices: monthsIndexed },
      { type: 'number', name: 'day', label: 'Day', minValue: 1, maxValue: 31 }
    ],
    onChange: ([ymd]) => ymd && setIntervalData((intervalData) => ({
      ...intervalData,
      start_date: {
        year: ymd.year,
        month: ymd.month,
        day: ymd.day
      }
    }))
  });

  let endDateYMD = tangibleFields.render({
    type: 'repeater',
    name: 'end_date',
    label: 'Ends On',
    value: [intervalData.end_date || {}],
    repeatable: false,
    fields: [
      {type: 'number', name: 'year', label: 'Year', minValue: 2000},
      {type: 'select', name: 'month', label: 'Month', choices: monthsIndexed},
      {type: 'number', name: 'day', label: 'Day', minValue: 1, maxValue: 31}
    ],
    onChange: ([ymd]) => ymd && setIntervalData((intervalData) => ({
      ...intervalData,
      end_date: {
        year: ymd.year,
        month: ymd.month,
        day: ymd.day
      }
    }))
  })

  return (
    <div className="recurring-field-group">
      <Periodicity
        state={[periodicity, setPeriodicity]}
        {...{frequencyTypes}}
        {...{fieldPrefix}}
      ></Periodicity>

      <DatePattern
        state={[datePatternFrom, setDatePatternFrom]}
        {...{periodicity}}
        {...{fieldPrefix}}
      ></DatePattern>

      <DatePattern
        state={[datePatternTo, setDatePatternTo]}
        {...{periodicity}}
        {...{fieldPrefix}}
      ></DatePattern>

      {startDateYMD}
      {endDateYMD}

    </div>
  )
}
